import { assessmentStatus } from '../../Constants';
import uuidv1 from 'uuid/v1';

import {
	UPDATE_VALUE,
	SET_USER_DATA,
	CLEAR_USER_DATA,
	GET_DATA,
	SET_TASK_RESPONSE,
	SET_RESP_AT_25MIN,
	SET_RESP_AT_30MIN,
	SET_RESP_AT_35MIN,
	SET_DEMOGRAPHICS_RESPONSE,
	SET_DATE_TIME_START,
	SET_SCREEN_DURATION,
	SET_TERMINATION,
	SET_ASSESSMENT_STATUS,
	REQUEST_START,
	REQUEST_SAVED,
	REQUEST_ERROR,
	REQUEST_END
} from '../actions/data-action';

const dataInitialState = {
	terms: null,
	termsDecline: null,
	consent: null,
	consentDecline: null,
	terminated: false,
	terminationReason: null,
	sessionID: null,
	outcomes: [],
	screens: []
};

const requestInitialState = {
	isProcessing: false,
	saved: false,
	hasError: false,
	error: ''
};

export const data = (data = dataInitialState, action) => {
	switch (action.type) {
		case UPDATE_VALUE:
			return {...data, ...action.obj}
		case SET_USER_DATA:
			const { userData } = action;
			const sessionID = data.sessionID ? data.sessionID : uuidv1();
			const inviteId = data.inviteId ? data.inviteId : uuidv1();
			userData.isLoggedIn = true;
			return Object.assign({}, data, { sessionID, inviteId, userData });

		case CLEAR_USER_DATA:
			data = dataInitialState;
			localStorage.clear();
			return Object.assign({}, data, {userData: {isLoggedIn: false}});
		
		case GET_DATA:
			return Object.assign({}, data, action.data);
						
		case SET_TASK_RESPONSE:
			let { index } = action;
			index = isNaN(index) ? 0 : index;
			const { task, taskType, subTaskType, response } = action;
			const tasks = Array.from(data.tasks);

			Object.values(tasks).find(item => item.id === taskType.id)[subTaskType.type].map(item => {
				if (item.id === task.id) {
					const respArray = item.response ? item.response : [];
					respArray[index] = response;
					item.response = respArray;
				}

				return item;
			});

			return Object.assign({}, data, { tasks });

		case SET_RESP_AT_25MIN:
			action.tasks[0].tasks.map(item => {
				item.respAt25min = item.response[0];
				return item;
			});

			return Object.assign({}, data, { tasks: action.tasks });

		case SET_RESP_AT_30MIN:
			action.tasks[0].tasks.map(item => {
				item.respAt30min = item.response[0];
				return item;
			});

			return Object.assign({}, data, { tasks: action.tasks });

		case SET_RESP_AT_35MIN:
			action.tasks[0].tasks.map(item => {
				item.respAt35min = item.response[0];
				return item;
			});

			return Object.assign({}, data, { tasks: action.tasks });

		case SET_DEMOGRAPHICS_RESPONSE:
			const demographics = { ...data.demographics };

			if (action.child) {
				demographics[action.child][action.name] = action.value;
			} else {
				demographics[action.name] = action.value;
			}

			return Object.assign({}, data, { demographics });

		case SET_DATE_TIME_START:
			if (!data.dateTimeStart) {
				data.dateTimeStart = new Date();
			}

			return Object.assign({}, data);

		case SET_SCREEN_DURATION:
			const screens = Array.from(data.screens);

			screens.map((item, index) => {
				if (item.url === action.url) {
					let duration = item.duration;
					duration = isNaN(duration) ? 0 : duration;
					item.duration = duration + action.duration;
				}

				return item;
			});

			return Object.assign({}, data, { screens });

		case SET_TERMINATION:
			if (data.terminated) {
				return data;
			}

			return Object.assign({}, data, { terminated: true, terminationReason: action.terminationReason });

		case SET_ASSESSMENT_STATUS:
			if (action.value === assessmentStatus.Complete || action.value === assessmentStatus.Fail) {
				return Object.assign({}, data, { status: action.value, dateTimeSubmitted: new Date()});
			}

			return Object.assign({}, data, { status: action.value, dateTimeSubmitted: null });

		default:
			return data;
	}
}

export const dataRequest = (request = requestInitialState, action) => {
    switch (action.type) {
        case REQUEST_START:
            return Object.assign({}, request, { isProcessing: true, saved: false, hasError: false, error: ''});
        case REQUEST_SAVED:
            return Object.assign({}, request, { saved: true});
        case REQUEST_ERROR:
            return Object.assign({}, request, { hasError: true, error: action.error});
        case REQUEST_END:
            return Object.assign({}, request, { isProcessing: false});
        default:
            return request;
    }
};